import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import type { IcmJob } from "@/icm/types";

const JobTotalPayoutCol: ColumnDef<IcmJob, unknown> = {
  id: "total_payout",
  header: "Total pay",
  meta: { size: "160px" },
  accessorFn: (row) => parseFloat(row.total_payout),
  cell: ({ row }) => (
    <div className="flex flex-col">
      <span className="tabular-nums">
        {formatMoney(row.original.total_payout)}
      </span>
      {row.original.payouts.length > 1 && (
        <span className="text-xs text-subtle tabular-nums">
          {row.original.payouts.length} items
        </span>
      )}
    </div>
  ),
};

export default JobTotalPayoutCol;
